<template>
  <div>
    <div class="top-btn-box">
      <input style="display:none" type="file" @change='importFileHandler' ref="fileRef">
      <button v-if="event==='modbus-device'&&editable" class="btn btn-sm btn-primary" @click="importData()">
        <i class="fa fa-download" aria-hidden="true"></i> 从模板导入</button>
    </div>

    <input-field label="设备名称" v-model="data.name" :disabled="!editable"></input-field>
    <select-field label="协议类型" v-model="data.protocolType" @input="protocolTypeChange" :list="[ 'TCP','RTU', 'ASCII']" :disabled="!editable||importModbusDevice"></select-field>
    <select-field label="挂载接口类型" v-model="data.interfaceType" @input="interfaceTypeChange" :list="interfaceTypes" :disabled="!editable||importModbusDevice"></select-field>
    <select-field label="挂载接口实例" v-model="data.interface" :list="interfaceInstanceList" :disabled="!editable"></select-field>
    <template v-if="data.protocolType==='TCP'">
      <input-field label="IP 地址" v-model="data.address" :disabled="!editable"></input-field>
      <number-field label="端口号" v-model="data.port" :disabled="!editable"></number-field>
      <select-field label="设备类型" v-model="data.nodeType" :list="['网关节点','网关子节点']" :disabled="!editable"></select-field>
      <number-field v-if="data.nodeType==='网关子节点'" label="Unit ID" v-model="data.unitId" :disabled="!editable"></number-field>
    </template>
    <number-field v-if="data.protocolType&&data.protocolType!=='TCP'" label="设备地址" v-model="data.address" :disabled="!editable"></number-field>

    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
import InputField from '@/components/utils/input-field'
import NumberField from '@/components/utils/number-field'
import SelectField from '@/components/utils/select-field'
import SubmitField from '@/components/utils/submit-field'
import { DB, DBVersion } from '@/extensions/db'
import { newGuid } from '../../../utils'

export default {
  props: {
    defaults: {
      required: false,
      default: Object.create(null),
      type: Object
    },
    event: {
      required: false,
      default: 'interface',
      type: String
    },
    editable: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      data: {
        name: null,
        protocolType: null,
        interfaceType: null,
        interface: null,
        address: null,
        port: null,
        nodeType: null,
        unitId: null
      },
      importModbusDevice: false,
      _allInterface: []
    }
  },
  components: {
    InputField,
    SelectField,
    NumberField,
    SubmitField
  },
  methods: {
    refresh () {
      Object.keys(this.data).forEach(key => {
        this.data[key] = this.defaults[key]
      })
      if (this.data.unitId === 0) {
        this.data.unitId = null
      }
      this.importModbusDevice = this._saveImportChildItems = this._modbusDeviceId = null
    },
    importData () {
      this.$refs.fileRef.value = null
      this.$refs.fileRef.click()
    },
    importFileHandler () {
      const reader = new FileReader()
      const file = this.$refs.fileRef.files[0]
      reader.onloadend = e => {
        try {
          const importData = JSON.parse(e.target.result)
          if (importData.type !== 'modbusDevice') {
            throw new Error('err')
          }
          if (importData.version !== DBVersion) {
            this.$notify({group: 'alert', type: 'error', title: '导入出错,版本不一致'})
            return
          }
          this.importModbusDevice = true
          this.data = {
            name: null,
            protocolType: null,
            interfaceType: null,
            interface: null,
            address: null,
            port: null,
            nodeType: null,
            unitId: null
          }
          this._modbusDeviceId = newGuid()
          this.data.name = importData.model
          this.data.protocolType = importData.deviceArgs.protocolType
          this.data.interfaceType = importData.deviceArgs.interfaceType

          this._saveImportChildItems = () => {
            const modbusDatas = []
            let points = []
            let funcs = []
            importData.data.forEach(item => {
              const modbusDataId = newGuid()
              modbusDatas.push({
                modbusDeviceId: this._modbusDeviceId,
                id: modbusDataId,
                address: item.address,
                regNum: item.regNum,
                cmdType: item.cmdType
              })
              item.points.forEach(point => {
                const newPointId = newGuid()
                points.push({
                  modbusDataId,
                  offset: point.offset,
                  regNum: point.regNum,
                  id: newPointId
                })
                funcs = funcs.concat(point.function.map((func, index) => Object.assign(func, {
                  parentType: 'modbusDataPoint',
                  parentId: newPointId,
                  order: index + 1,
                  id: newGuid()
                })
              ))
              })
            })

            Promise.all([DB.modbusData.bulkAdd(modbusDatas), DB.modbusDataPoint.bulkAdd(points), DB.func.bulkAdd(funcs)]).then(() => this.$emitter.emit('reload-device-tree'))
          }
        } catch (e) {
          this.$notify({group: 'alert', type: 'error', title: '导入出错'})
        }
      }
      reader.readAsText(file)
    },
    protocolTypeChange () {
      Object.assign(this.data, {
        interfaceType: null,
        interface: null,
        address: null,
        port: null,
        nodeType: null,
        unitId: null
      })
    },
    interfaceTypeChange () {
      this.data.interface = null
    },
    submit () {
      if (this.data.nodeType === '网关节点') {
        this.data.unitId = 0
      }
      this.$emitter.emit(
        this.event,
        Object.assign(this.data, {
          _id: this._modbusDeviceId || this.defaults._id,
          module:
            this.data.protocolType === 'TCP'
              ? 'dpe-modbus-tcp'
              : 'dpe-modbus-serial'
        })
      )

      this.$emitter.once(`${this.event}Resp`, err => {
        if (!err) {
          this.editable = false
          this._saveImportChildItems && this._saveImportChildItems()
        }
      })
    }
  },
  async created () {
    this._allInterface = await DB.interface.toArray()
    this.refresh()
  },
  watch: {
    defaults () {
      this.refresh()
    }
  },
  computed: {
    interfaceTypes () {
      var interfaceTypes = []
      if (this.data.protocolType) {
        if (this.data.protocolType === 'TCP') {
          interfaceTypes = ['NET']
        } else {
          interfaceTypes = ['RS485', 'RS232']
        }
      }
      return interfaceTypes
    },
    interfaceInstanceList () {
      const interfaceType = this.data.interfaceType
      var res = []
      if (interfaceType) {
        res = this._allInterface
          .filter(item => item.type === interfaceType)
          .map(item => ({
            key: item.name,
            value: item.id
          }))
      }
      return res
    },
    isValid () {
      return true
    }
  }
}
</script>

<style>
.top-btn-box{
  display: flex;
  justify-content: flex-end;
  padding:0 30px 20px;
  /* padding-right: 30px; */
}
</style>



// WEBPACK FOOTER //
// src/components/home/forms/modbus-device.vue